import React, { FC } from 'react';

export type UserNameCellProps = { value: string; activated?: number | boolean };

export const UserNameCell: FC<UserNameCellProps> = ({ value, activated }) => (
  <div className="d-flex gap-2 fw-bold fs-6">
    {activated === 0 && <p className="text-danger">(pending)</p>}
    <p className="text-wrap text-break text-white">{value}</p>
  </div>
);

export default UserNameCell;
